import { ProductGallery } from "theme";

ProductGallery.prototype.openZoom = function (index = 0) {
  const visibleMedia = Array.from(this.querySelectorAll(".product-gallery__media")).filter(media => media.offsetParent !== null);
  const selectedMedia = index < 0 ? this.querySelector("media-carousel")?.selectedSlide : visibleMedia.filter(media => media.dataset.mediaType === "image")[index];
  const slides = visibleMedia.filter(media => media.dataset.mediaType === "image" || (media.dataset.mediaType === "video" && media.querySelector("video")));
  const dataSource = slides.map(media => {
    const image = media.querySelector("img");
    if (media.dataset.mediaType === "video") {
      const sourceVideo = media.querySelector("video");
      return { type: "nano-video", sourceVideo, poster: image?.currentSrc || image?.src, thumbnailElement: image, width: Number(image?.getAttribute("width")) || 1920, height: Number(image?.getAttribute("height")) || 1080 };
    }
    return { thumbnailElement: image, src: image.src, srcset: image.srcset, msrc: image.currentSrc || image.src, width: Number(image.getAttribute("width")), height: Number(image.getAttribute("height")), alt: image.alt, thumbCropped: true };
  });
  if (!dataSource.length) return;
  const lightbox = this.photoswipe;
  if (!lightbox.nanoVideoEnabled) {
    lightbox.nanoVideoEnabled = true;
    const pauseVideo = content => content?.element?.querySelector("video")?.pause();
    lightbox.on("contentLoad", event => {
      if (event.content.type !== "nano-video") return;
      event.preventDefault();
      const container = document.createElement("div");
      container.style.cssText = "display:flex;align-items:center;justify-content:center;width:100%;height:100%;box-sizing:border-box";
      const video = event.content.data.sourceVideo.cloneNode(true);
      video.removeAttribute("id");
      video.removeAttribute("autoplay");
      video.removeAttribute("loop");
      video.controls = true;
      video.playsInline = true;
      video.preload = "metadata";
      if (event.content.data.poster) video.poster = event.content.data.poster;
      video.style.cssText = "display:block;width:100%;height:100%;object-fit:contain;pointer-events:auto";
      container.appendChild(video);
      event.content.element = container;
      event.content.state = "loaded";
    });
    lightbox.on("contentDeactivate", event => pauseVideo(event.content));
    lightbox.on("contentRemove", event => pauseVideo(event.content));
    lightbox.on("close", () => pauseVideo(lightbox.pswp?.currSlide?.content));
    lightbox.addFilter("preventPointerEvent", (prevent, event) => event.target?.closest?.("video") ? false : prevent);
  }
  this.querySelectorAll("video").forEach(video => video.pause());
  lightbox.loadAndOpen(Math.max(0, slides.indexOf(selectedMedia)), dataSource);
};
